import PropTypes from 'prop-types';
import { DATA_LAYER_OPTIONS } from '../../constants';
import { buildTransactionId, pushPurchase } from '../../utils/data-layer';
import { extractListingDataLayerData, filterContacts } from '../../utils/transformers';
import PortalAdapter from '../PortalAdapter';

const PhoneButtonContent = ({ close, contacts }) => {
  const handleClickOnBrokerLogo = contact => {
    const dataLayerPayload = extractListingDataLayerData(yachtData, contacts);

    const personalizedPayload = {
      ...dataLayerPayload,
      brokerIds: contact.brokerId,
      brokerNames: contact.brokerName
    };

    const transactionId = buildTransactionId(yachtData.id);
    pushPurchase(personalizedPayload, DATA_LAYER_OPTIONS.WEBSITE, transactionId);
  };

  const filteredContacts = filterContacts(contacts);

  let numberOfContactsVariant = 1;
  if (filteredContacts.length === 2) {
    numberOfContactsVariant = 2;
  }

  if (filteredContacts.length > 2) {
    numberOfContactsVariant = 3;
  }

  return (
    <PortalAdapter>
      <div className="ecommerce__form__overlay">
        <div
          className={`ecommerce__form__modal ecommerce__form__modal--phone-${numberOfContactsVariant}`}>
          <div className="ecommerce__form ecommerce__form--phone">
            <div role="button" className="ecommerce__form__close" onClick={close}>
              <i className="fas fa-times" />
            </div>

            <h2 className="ecommerce__form__phone-title">Call the broker</h2>

            <div className="ecommerce__form__phone-numbers">
              {filteredContacts.map((contact, i) => (
                <div key={i} className="ecommerce__form__phone-number-wrapper">
                  <p className="ecommerce__form__phone-number">
                    {contact.name}

                    <a
                      className="ecommerce__form__phone-number__callable"
                      href={`tel:${contact.phone.replace(/ /g, '-')}`}>
                      {contact.phone}
                    </a>
                  </p>

                  <a
                    href={contact.website}
                    onClick={() => handleClickOnBrokerLogo(contact)}
                    className="image__wrapper"
                    target="_blank"
                    rel="noreferrer">
                    <img src={contact.image.url} alt={contact.image.alt} className="image" />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </PortalAdapter>
  );
};

PhoneButtonContent.propTypes = {
  close: PropTypes.func.isRequired,
  contacts: PropTypes.array.isRequired
};

export default PhoneButtonContent;
